import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient, keepPreviousData } from "@tanstack/react-query";
import { coursegroupsApi } from "./coursegroupsApi";

export const useCourseGroupCourses = (courseGroupId: string | undefined) => {
  const queryClient = useQueryClient();
  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.COURSE_GROUP_COURSES(Number(courseGroupId)),
    queryFn: () => coursegroupsApi.fetchCourses(Number(courseGroupId)),
    enabled: !!courseGroupId,
    placeholderData: keepPreviousData,
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.COURSE_GROUP_COURSES(Number(courseGroupId)),
    });
  };

  return { invalidate, isLoading, isFetching, courses: data?.data.courses ?? [] };
};
